import { render } from "./CustomsDeclarationSectionTwo.vue?vue&type=template&id=54aa40c3&scoped=true"
import script from "./CustomsDeclarationSectionTwo.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationSectionTwo.vue?vue&type=script&lang=js"

import "./CustomsDeclarationSectionTwo.vue?vue&type=style&index=0&id=54aa40c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54aa40c3"]])

export default __exports__